import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { CourseIndexView } from '../../../types/courses';
import { CourseApis } from '../../../apis/courses';

export type CourseListType = 'all' | 'design' | 'marketing';

export const COURSE_LIST_TYPES = [
    { value: 'all', label: '全て' },
    { value: 'design', label: 'デザイン' },
    { value: 'marketing', label: 'マーケティング' },
];

export class CourseListPageState {
    @observable preview: boolean = false;
    @observable courseListType: CourseListType = 'all';
    @observable courses: RemoteResourceV3<CourseIndexView[]> = RemoteResourceV3.loading();

    @action.bound
    async init(preview: boolean) {
        this.preview = preview;
        this.reloadCourses();
    }

    @action.bound
    async reloadCourses() {
        await updateRemoteResourceV3(this.courses, (v) => (this.courses = v), () => CourseApis.index(this.preview));
    }

    @action.bound
    setListType(type: CourseListType) {
        this.courseListType = type;
    }
}
